import React, { useEffect, useState } from "react";
import GoogleIcon from "../../../assets/images/jpeg/google_review.png";
import AvatarImage from "../../../assets/images/png/user.svg";
import SkeletonCard from "../../../components/blocks/SkeletonCard";
import StoryModal from "../../../components/modals/StoryModal";
import FacebookIcon from "../../../components/svgs/FacebookIcon";
import InstagramIcon from "../../../components/svgs/InstagramIcon";
import LinkedInIcon from "../../../components/svgs/LinkedInIcon";
import TwitterIcon from "../../../components/svgs/TwitterIcon";
import { getStoriesApi } from "../../../store/actions/storiesActions";
import styles from "./style.module.css";

const Card = ({ handleShowStory, testimony }) => {
  return (
    <div
      onClick={handleShowStory}
      className={`${styles.testimonialsSectionCard} w-full bg-white rounded-[20px] px-6 pt-8 lg:pt-12 pb-10 lg:px-8 flex flex-col justify-between`}
    >
      <div className="flex-1">
        {testimony?.storyLink && (
          <div className="mb-4">
            <a
              href={testimony?.storyLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              {testimony?.storyLink?.includes("linkedin") ? (
                <LinkedInIcon />
              ) : testimony?.storyLink?.includes("x") ? (
                <TwitterIcon />
              ) : testimony?.storyLink?.includes("facebook") ? (
                <FacebookIcon />
              ) : testimony?.storyLink?.includes("instagram") ? (
                <InstagramIcon />
              ) : testimony?.storyLink?.includes("google") ||
                testimony?.storyLink?.includes("goo.gl") ? (
                <div className="w-14">
                  <img src={GoogleIcon} alt="Google" />
                </div>
              ) : (
                <></>
              )}
            </a>
          </div>
        )}
        <p className="text-sm-15 lg:text-base lg:leading-7 text-default">
          {testimony?.experience?.length > 160
            ? testimony?.experience?.slice(0, 160) + "..."
            : testimony?.experience}
        </p>
      </div>
      <div className="flex items-center gap-3 pt-4">
        <div className="w-10 h-10 lg:w-11 lg:h-11 rounded-full bg-black">
          <img
            src={
              testimony?.imageUrl?.includes("cloudinary")
                ? AvatarImage
                : testimony?.imageUrl
            }
            alt=""
            className="w-full h-full rounded-full object-center object-cover"
            loading="lazy"
          />
        </div>
        <div className="flex-1 flex flex-col">
          <p className="text-sm font-bold">{testimony?.name}</p>
          <p className="text-xs">{testimony?.companyRole}</p>
        </div>
      </div>
    </div>
  );
};

const TestimonialsSection = () => {
  const [stories, setStories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedTestimony, setSelectedTestimony] = useState({});

  const handleShowStory = (val) => {
    setSelectedTestimony(val);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  const fetchData = async (params) => {
    setLoading(true);
    try {
      const response = await getStoriesApi(params);
      setStories(response?.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    const params = {
      approve: true,
      limit: 12,
    };
    fetchData(params);
  }, []);

  // Duplicate the stories to create a seamless loop effect
  const duplicateStories = (stories) => {
    return [...stories, ...stories];
  };

  const firstRowStories = stories?.slice(0, Math.ceil(stories.length / 2));
  const secondRowStories = stories?.slice(Math.ceil(stories.length / 2));

  return (
    <>
      <section
        className={`pt-20 lg:pt-24 pb-20 lg:pb-28 bg-primary overflow-hidden ${styles.testimonialsSection}`}
      >
        <div className="container mx-auto px-4">
          <div className="flex flex-col justify-center text-center items-center mx-auto w-full md:w-10/12 ">
            <div>
              <p className="flex items-center text-center justify-center font-poppins gap-3 text-secondary text-sm font-extrabold tracking-[0.1em] uppercase mb-5">
                <span className="w-8 h-[3px] bg-secondary inline-block"></span>
                SHARED IN THEIR OWN WORDS
              </p>
              <h2 className="text-white font-poppins text-3xl lg:text-4xl xl:text-6xl  font-bold">
                Real learning journeys, shared across the web.
              </h2>

              <p className="mt-6 mx-auto text-center text-white text-sm-15 lg:text-base xl:text-lg lg:leading-7 xl:leading-8 w-full md:w-9/12">
                Move through reflections from learners and alumni on Google
                Reviews, LinkedIn and X. Hover or focus on a card to pause the
                wall.
              </p>
            </div>
          </div>
        </div>
        <div className="relative mt-12">
          {loading ? (
            <div className="container mx-auto px-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6">
              {Array.from({ length: 8 }).map((_, idx) => (
                <SkeletonCard
                  key={idx}
                  className={styles.testimonialsSectionCard}
                />
              ))}
            </div>
          ) : (
            <div className={styles.carouselContainer}>
              <div className={`${styles.carouselRow} ${styles.scrollRight}`}>
                {duplicateStories(firstRowStories)?.map((datum, index) => (
                  <Card
                    key={index}
                    testimony={datum}
                    handleShowStory={() => handleShowStory(datum)}
                  />
                ))}
              </div>
              <div
                className={`${styles.carouselRow} ${styles.scrollLeft} mt-0`}
              >
                {duplicateStories(secondRowStories)?.map((datum, index) => (
                  <Card
                    key={index}
                    testimony={datum}
                    handleShowStory={() => handleShowStory(datum)}
                  />
                ))}
              </div>
            </div>
          )}
        </div>
      </section>
      {showModal && (
        <StoryModal
          show={showModal}
          handleModalClose={handleClose}
          selectedTestimony={selectedTestimony}
        />
      )}
    </>
  );
};

export default TestimonialsSection;
